/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronRight: {
  name: 'chevron-right';
  data: string;
} = {
  name: 'chevron-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.646 3.646a.5.5 0 0 1 .708 0l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L9.293 8 5.646 4.354a.5.5 0 0 1 0-.708Z" fill="currentColor"/></svg>`,
};
